var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useState } from "react";
import { useTreeMenuData } from "@/components/menu/items/use-tree-menu-hook";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { Box, Typography, styled } from "@mui/material";
import { BooleanInput, NumberInput, ReferenceInput, SaveButton, SelectInput, SimpleForm, TextInput, Toolbar, useGetOne, useRedirect, } from "react-admin";
import { JsonInput } from "react-admin-json-view";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NewResourceContext } from "@/providers/NewResourceProvider";
import { addDefaultTranslationsToElement } from "@/services/i18n";
import { useMutation } from "@apollo/client";
import { CREATE_ELECTION } from "@/queries/CreateElection";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
import { serializeIvrEntityAnnotations } from "@/utils/ivr";
var Hidden = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: none;\n"], ["\n    display: none;\n"])));
export var CreateElection = function () {
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var searchParams = useSearchParams()[0];
    var redirect = useRedirect();
    var _a = useState(), settings = _a[0], setSettings = _a[1];
    var electionEventId = searchParams.get("electionEventId");
    var createElection = useMutation(CREATE_ELECTION)[0];
    var electionEvent = useGetOne("sequent_backend_election_event", {
        id: electionEventId,
    }).data;
    var tenant = useGetOne("sequent_backend_tenant", {
        id: tenantId,
    }).data;
    var refetch = useTreeMenuData(false).refetch;
    var setLastCreatedResource = useContext(NewResourceContext).setLastCreatedResource;
    var setElectionIdFlag = useElectionEventTallyStore().setElectionIdFlag;
    useEffect(function () {
        if (tenant) {
            var temp = tenant === null || tenant === void 0 ? void 0 : tenant.settings;
            setSettings(temp);
        }
    }, [tenant]);
    var transform = function (data) {
        var _a, _b, _c, _d;
        var i18n = addDefaultTranslationsToElement(data);
        var tenantLangConf = (_b = (_a = tenant === null || tenant === void 0 ? void 0 : tenant.settings) === null || _a === void 0 ? void 0 : _a.language_conf) !== null && _b !== void 0 ? _b : {
            enabled_language_codes: (_c = settings === null || settings === void 0 ? void 0 : settings.languages) !== null && _c !== void 0 ? _c : ["en"],
            default_language_code: "en",
        };
        tenantLangConf.default_language_code = (_d = tenantLangConf.default_language_code) !== null && _d !== void 0 ? _d : "en";
        var presentation = __assign(__assign({}, data.presentation), { i18n: i18n, language_conf: tenantLangConf });
        data.annotations = serializeIvrEntityAnnotations(data.annotations);
        return __assign(__assign({}, data), { presentation: presentation });
    };
    var onSubmit = function (input0) { return __awaiter(void 0, void 0, void 0, function () {
        var electionSubmit, i18n, tenantLangConf, parentLangConf, presentation, data, id, e_1;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    electionSubmit = input0;
                    i18n = addDefaultTranslationsToElement(electionSubmit);
                    tenantLangConf = (_b = (_a = tenant === null || tenant === void 0 ? void 0 : tenant.settings) === null || _a === void 0 ? void 0 : _a.language_conf) !== null && _b !== void 0 ? _b : {
                        enabled_language_codes: (_c = settings === null || settings === void 0 ? void 0 : settings.languages) !== null && _c !== void 0 ? _c : ["en"],
                        default_language_code: "en",
                    };
                    tenantLangConf.default_language_code = (_d = tenantLangConf.default_language_code) !== null && _d !== void 0 ? _d : "en";
                    parentLangConf = (_f = (_e = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) === null || _e === void 0 ? void 0 : _e.language_conf) !== null && _f !== void 0 ? _f : tenantLangConf;
                    presentation = __assign(__assign({}, input0.presentation), { i18n: i18n, language_conf: parentLangConf });
                    electionSubmit = __assign(__assign({}, electionSubmit), { presentation: presentation });
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createElection({
                            variables: {
                                electionEventId: electionEventId,
                                externalId: electionSubmit.external_id,
                                presentation: electionSubmit.presentation,
                                description: electionSubmit.description,
                            },
                        })];
                case 2:
                    data = (_h.sent()).data;
                    id = (_g = data === null || data === void 0 ? void 0 : data.create_election) === null || _g === void 0 ? void 0 : _g.id;
                    if (id) {
                        refetch();
                        setLastCreatedResource({ id: id, type: "sequent_backend_election" });
                        setElectionIdFlag(id);
                        redirect("/sequent_backend_election/".concat(id));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _h.sent();
                    console.log(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(SimpleForm, { onSubmit: onSubmit, toolbar: _jsx(Toolbar, { children: _jsx(SaveButton, { className: "election-save-button" }) }), children: [_jsx(Typography, { variant: "h4", children: t("common.resources.election") }), _jsx(Typography, { variant: "body2", children: t("createResource.election") }), _jsx(TextInput, { source: "name", required: true, label: String(t("electionScreen.field.name")) }), _jsx(TextInput, { source: "external_id", label: String(t("electionScreen.field.externalId")), required: true }), _jsx(TextInput, { source: "description", label: String(t("electionScreen.field.description")) }), _jsxs(Hidden, { children: [_jsx(BooleanInput, { source: "is_consolidated_ballot_encoding" }), _jsx(BooleanInput, { source: "spoil_ballot_option" }), _jsx(ReferenceInput, { source: "tenant_id", reference: "sequent_backend_tenant", children: _jsx(SelectInput, { optionText: "slug", defaultValue: tenantId }) }), _jsx(ReferenceInput, { source: "election_event_id", reference: "sequent_backend_election_event", children: _jsx(SelectInput, { optionText: "name", defaultValue: electionEventId }) }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                            name: null,
                            collapsed: true,
                            enableClipboard: true,
                            displayDataTypes: false,
                        } }), _jsx(JsonInput, { source: "annotations", jsonString: false, reactJsonOptions: {
                            name: null,
                            collapsed: true,
                            enableClipboard: true,
                            displayDataTypes: false,
                        } }), _jsx(JsonInput, { source: "presentation", jsonString: false, reactJsonOptions: {
                            name: null,
                            collapsed: true,
                            enableClipboard: true,
                            displayDataTypes: false,
                        } }), _jsx(JsonInput, { source: "dates", jsonString: false, reactJsonOptions: {
                            name: null,
                            collapsed: true,
                            enableClipboard: true,
                            displayDataTypes: false,
                        } }), _jsx(JsonInput, { source: "status", jsonString: false, reactJsonOptions: {
                            name: null,
                            collapsed: true,
                            enableClipboard: true,
                            displayDataTypes: false,
                        } }), _jsx(TextInput, { source: "eml" }), _jsx(NumberInput, { source: "num_allowed_revotes" })] })] }));
};
var templateObject_1;
